import tags from '~/assets/util/tags'

export function getTagsBySportType (sportType) {
	const tagsBySportType = tags[sportType]

	if (!sportType || !tagsBySportType) {
		return [...tags.default]
	}
	return [...tags.default, ...tagsBySportType]
}

export function formatVideoTime (time) {
	const hrs = Math.floor(time / 3600)
	const mins = Math.floor((time % 3600) / 60)
	const secs = Math.floor(time % 60)

	let ret = ''
	if (hrs > 0) {
		ret += '' + hrs + ':' + (mins < 10 ? '0' : '')
	}
	ret += '' + mins + ':' + (secs < 10 ? '0' : '')
	ret += '' + secs
	return ret
}

export function getAttributesFromTag (tag) {
	return {
		type: tag.tagType,
		name: tag.name,
		startTime: tag.startTime,
		endTime: tag.endTime,
		...(tag.player && { player: tag.player })
	}
}

export const findTagIconByType = (type, sportType) => {
	const tagsBySportType = tags[sportType]

	if (!type || !sportType || !tagsBySportType) {
		return tags.default[0].icon
	}

	const result = tagsBySportType.find(tag => tag.type === type)

	const defaultIcon = tags.default.find(tag => tag.type === type)

	if (!result) {
		return defaultIcon?.icon || tags.default[0].icon
	}

	return result.icon
}

export const isSportTypeAvailableForTags = (sportType) => {
	const availableSports = ['basketball', 'soccer', 'volleyball', 'hockey', 'baseball', 'softball', 'lacrosse', 'lacrosse-men', 'lacrosse-women', 'fieldhockey']

	return availableSports.includes(sportType)
}
